module.exports = __webpack_public_path__ + "media/assets/images/rain_sometime_will_snow-95c0961f4c7853ee59818dc4243fc03f.png";